
interface HowToProps {
  name: string;
  description: string;
  steps: {
    name: string;
    text: string;
    image?: string;
    url?: string;
  }[];
  totalTime?: string;
  estimatedCost?: {
    currency: string;
    value: number;
  };
  supply?: string[];
  tool?: string[];
}

/**
 * Generate HowTo schema for guides and process explanations
 */
export function generateHowToSchema(howTo: HowToProps) {
  return {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": howTo.name,
    "description": howTo.description,
    "step": howTo.steps.map((step, index) => ({
      "@type": "HowToStep",
      "position": index + 1,
      "name": step.name,
      "text": step.text,
      ...(step.image && {
        "image": {
          "@type": "ImageObject",
          "url": step.image
        }
      }),
      ...(step.url && { "url": step.url })
    })),
    ...(howTo.totalTime && { "totalTime": howTo.totalTime }),
    ...(howTo.estimatedCost && {
      "estimatedCost": {
        "@type": "MonetaryAmount",
        "currency": howTo.estimatedCost.currency,
        "value": howTo.estimatedCost.value
      }
    }),
    ...(howTo.supply && { "supply": howTo.supply }),
    ...(howTo.tool && { "tool": howTo.tool })
  };
}
